import {
  Devider,
  Flex,
  Text,
  PaginationProvider,
  ModalProvider,
} from 'dash-ui';
import { useTranslation } from 'react-i18next';
import { GetPropertyByIdQuery } from 'gql/generated.graphql';

import SetNoteForm from 'containers/properties/PropertyNote/components/SetNoteForm/SetNoteForm';
import PropertyNoteList from 'containers/properties/PropertyNote/components/PropertyNoteList/PropertyNoteList';
import DeletePropertyNoteModal from 'containers/properties/PropertyNote/components/DeletePropertyNoteModal/DeletePropertyNoteModal';

function PropertyNote({
  property,
}: {
  property: GetPropertyByIdQuery['getPropertyById'];
}) {
  const { t } = useTranslation(['pages']);
  return (
    <Flex flexDirection="column" flex={1} w="100%">
      <Flex my={2} mx={4}>
        <Text semibold lg>
          {t('pages:propertyPage:propertyNote')}
        </Text>
      </Flex>
      <PaginationProvider perPage={10}>
        <>
          <Flex w="100%" pt={2} pb={4} px={4}>
            <SetNoteForm propertyId={property._id} />
          </Flex>
          <Devider w="100%" />
          <Flex w="100%" pb={2} px={4}>
            <ModalProvider>
              <>
                <PropertyNoteList propertyId={property._id} />

                <DeletePropertyNoteModal propertyId={property._id} />
              </>
            </ModalProvider>
          </Flex>
        </>
      </PaginationProvider>
    </Flex>
  );
}

export default PropertyNote;
